import { render, staticRenderFns } from "./CatalogoArmas.vue?vue&type=template&id=e8882c36"
import script from "./CatalogoArmas.vue?vue&type=script&lang=js"
export * from "./CatalogoArmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports